import { Injectable } from '@angular/core';
import { TenantRoles } from '@sal/shared/domain/value-objects';
import { matchTenantHostname } from '../utils/tenant-hostname.util';

export const SAL_THEME_STORAGE_KEY = 'sal-theme';

export type AppTheme = TenantRoles.SAG | TenantRoles.SE | TenantRoles.SHS;

const THEME_CSS_CLASS: Record<AppTheme, string> = {
    [TenantRoles.SAG]: 'theme-sag',
    [TenantRoles.SE]: 'theme-energy',
    [TenantRoles.SHS]: 'theme-shs'
};

const OVERRIDE_THEMES: Record<string, AppTheme> = {
    sag: TenantRoles.SAG,
    energy: TenantRoles.SE,
    shs: TenantRoles.SHS
};

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    public getThemeForHostname(hostname = window.location.hostname): AppTheme {
        return matchTenantHostname(hostname) ?? TenantRoles.SAG;
    }

    // Added this so a theme can be forced for local development/testing without needing a
    // matching hostname: sessionStorage.setItem('sal-theme', 'sag' | 'energy' | 'shs')
    public getOverrideTheme(): AppTheme | null {
        try {
            const stored = sessionStorage.getItem(SAL_THEME_STORAGE_KEY);
            return stored ? (OVERRIDE_THEMES[stored.toLowerCase()] ?? null) : null;
        } catch {
            return null;
        }
    }

    public resolveActiveTheme(): AppTheme {
        return this.getOverrideTheme() ?? this.getThemeForHostname();
    }

    public initTheme(): void {
        const theme = this.resolveActiveTheme();
        const body = document.body;
        Object.values(THEME_CSS_CLASS).forEach(cssClass => body.classList.remove(cssClass));
        body.classList.add(THEME_CSS_CLASS[theme]);
    }
}
